'use client';

function getPreviousIndex(currentIndex, elements, loop) {
  for (var i = currentIndex - 1; i >= 0; i -= 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  if (loop) {
    for (var _i = elements.length - 1; _i > -1; _i -= 1) {
      if (!elements[_i].hasAttribute("data-combobox-disabled")) {
        return _i;
      }
    }
  }
  return currentIndex;
}
function getNextIndex(currentIndex, elements, loop) {
  for (var i = currentIndex + 1; i < elements.length; i += 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  if (loop) {
    for (var _i2 = 0; _i2 < elements.length; _i2 += 1) {
      if (!elements[_i2].hasAttribute("data-combobox-disabled")) {
        return _i2;
      }
    }
  }
  return currentIndex;
}
function getFirstIndex(elements) {
  for (var i = 0; i < elements.length; i += 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  return -1;
}
export { getFirstIndex, getNextIndex, getPreviousIndex };